import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const MovieDetails = styled.div`
  width: 100vw;
  max-width: 1368px;
  min-width: 288px;
  width: auto;
  margin: auto;
`;
